import * as tslib_1 from "tslib";
import * as React from 'react';
import datapoints from '../datapoints';
import getInstrumentationContextsFromTableView from 'owa-mail-list-store/lib/utils/getInstrumentationContextsFromTableView';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import MailListItemIconBar from './MailListItemIconBar';
import MailListItemRichPreviewWell from './MailListItemRichPreviewWell';
import MailListItemSelectionSource from 'owa-mail-store/lib/store/schema/MailListItemSelectionSource';
import MailListItemTwistyButton from './MailListItemTwistyButton';
import onMailListItemClickHandler from '../utils/onMailListItemClickHandler';
import PersonaCheckbox from './PersonaCheckbox';
import strings from 'owa-strings/owa-mail-strings';
import { mailStore } from 'owa-mail-store';
import { CategoryWell } from 'owa-categories';
import { computed } from 'mobx';
import { CouponPreviewWell } from 'owa-mail-coupon-peek';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import { FolderTag } from 'owa-mail-list-view';
import { getFormattedDate } from 'owa-mail-store-actions';
import { highlightTermsInHtmlElement } from 'owa-highlight';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { lazyStartSearchWithCategory } from 'owa-mail-search';
import { lazyStartSearchWithCategory as legacyLazyStartSearchWithCategory } from 'owa-mail-search-actions';
import { logUsage } from 'owa-analytics';
import { observer } from 'mobx-react';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import { trace } from 'owa-trace';
var styles = require('./MailListItem.scss');
var classNames = require('classnames/bind').bind(styles);
var MailListItem = /** @class */ (function (_super) {
    tslib_1.__extends(MailListItem, _super);
    function MailListItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.highLightTerms = function (element) {
            highlightTermsInHtmlElement(element, _this.props.mailListTableProps.highlightTerms);
        };
        _this.onAttachmentClick = function (evt) {
            return onMailListItemClickHandler(evt, MailListItemSelectionSource.MailListItemRichPreview, _this.props.mailListItemDataProps.rowKey, _this.props.mailListTableProps.tableViewId);
        };
        _this.renderTimestamp = function (isUnread) {
            // Do not show lastDeliveryTime when the item has a returnTime
            if (_this.props.mailListItemDataProps.returnTime) {
                return null;
            }
            // VSO: 26555 - Remove the extra tracing added to MailListItem to determine when lastDeliveryTime is undefined
            if (!_this.props.mailListItemDataProps.lastDeliveryTimestamp) {
                var tableView = listViewStore.tableViews.get(_this.props.mailListTableProps.tableViewId);
                if (!tableView) {
                    trace.error('renderTimestamp: LastDeliveryTimeStamp is undefined and tableView is null');
                }
                else {
                    var type = tableView.tableQuery.type;
                    var listViewType = tableView.tableQuery.listViewType;
                    trace.error('renderTimestamp: LastDeliveryTimeStamp is undefined,' +
                        ' table type is ' +
                        type +
                        ' list type ' +
                        listViewType);
                }
                return null;
            }
            var formattedDate = getFormattedDate(_this.props.mailListItemDataProps.lastDeliveryTimestamp);
            return (React.createElement("span", { className: !_this.props.mailListTableProps.isSingleLine && isUnread
                    ? styles.timestampUnread
                    : styles.timestamp, title: formattedDate }, formattedDate));
        };
        /**
         * Renders a tag that shows user what folder mail item is actually in.
         */
        _this.renderFolderTag = function () {
            var tableProps = _this.props.mailListTableProps;
            if (tableProps.showFolderTag) {
                var itemProps = _this.props.mailListItemDataProps;
                return (React.createElement(FolderTag, { folderId: itemProps.parentFolderId, isPreviewTextOn: tableProps.showPreviewText, isSingleLine: tableProps.isSingleLine, isUnread: itemProps.unreadCount > 0 }));
            }
            return null;
        };
        _this.onCategoryClicked = function (ev, category, actionSource) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var startSearchWithCategory;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Need stop propagation so the click doesn't bubble up to container, i.e list view item and reading pane subject
                        ev.stopPropagation();
                        if (!isMailFeatureEnabled('sea-commonSearchBox')) return [3 /*break*/, 2];
                        return [4 /*yield*/, lazyStartSearchWithCategory.import()];
                    case 1:
                        startSearchWithCategory = _a.sent();
                        startSearchWithCategory(actionSource, category);
                        return [3 /*break*/, 3];
                    case 2:
                        legacyLazyStartSearchWithCategory(category, actionSource);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.renderCategories = function (categories, categoryWellContainerClass) {
            return (React.createElement(CategoryWell, { key: _this.props.mailListItemDataProps.rowId, categoryWellContainerClass: categoryWellContainerClass, categoryContainerClass: styles.categoryContainer, categories: categories, onCategoryClicked: _this.onCategoryClicked }));
        };
        _this.stopPropagation = function (evt) {
            evt.stopPropagation();
        };
        return _this;
    }
    Object.defineProperty(MailListItem.prototype, "isLoadingExpansion", {
        get: function () {
            var expansionState = listViewStore.expandedConversationViewState;
            var conversationItemParts = mailStore.conversations.get(this.props.mailListItemDataProps.conversationId);
            return (expansionState.expandedRowKey == this.props.mailListItemDataProps.rowKey &&
                expansionState.shouldBeExpanded &&
                conversationItemParts &&
                conversationItemParts.loadingState.isLoading);
        },
        enumerable: true,
        configurable: true
    });
    MailListItem.prototype.renderUnreadCount = function (unreadCount) {
        var unreadCountClasses = classNames(styles.unreadCount, styles.flex00Auto);
        return unreadCount > 1 && React.createElement("span", { className: unreadCountClasses },
            "(",
            unreadCount,
            ")");
    };
    MailListItem.prototype.renderDraftsPlaceHolder = function () {
        // For drafts we always prepend the placeholder [Drafts]{space}
        var draftsPlaceHolderText = strings.draftSenderPersonaPlaceholder + ' ';
        return React.createElement("span", { className: styles.draftText }, draftsPlaceHolderText);
    };
    MailListItem.prototype.renderCondensedRowText = function (text, tooltipText, shouldShowDraftsIndicator) {
        return (React.createElement("div", { className: styles.condensedRowText },
            shouldShowDraftsIndicator && this.renderDraftsPlaceHolder(),
            this.renderLineText(text, tooltipText)));
    };
    MailListItem.prototype.renderFirstLineText = function (firstLineText, firstLineTooltipText, shouldShowDraftsIndicator, isUnread, showBrandDecoration) {
        var firstLineTextClasses = classNames(isUnread ? styles.firstLineTextUnread : styles.firstLineTextRead);
        return (React.createElement("div", { className: firstLineTextClasses },
            shouldShowDraftsIndicator && this.renderDraftsPlaceHolder(),
            this.renderLineText(firstLineText, firstLineTooltipText),
            showBrandDecoration && (React.createElement(Icon, { iconName: "CompletedSolid" /* CompletedSolid */, className: styles.brandIcon }))));
    };
    MailListItem.prototype.renderSecondLineText = function (secondLineText, secondLineTooltipText) {
        return this.renderLineText(secondLineText, secondLineTooltipText);
    };
    MailListItem.prototype.renderLineText = function (text, tooltipText) {
        return tooltipText ? (React.createElement(TooltipHost, { content: tooltipText, calloutProps: { gapSpace: 0 }, directionalHint: 0 /* topLeftEdge */ },
            React.createElement("span", { ref: this.highLightTerms }, text))) : (React.createElement("span", { ref: this.highLightTerms }, text));
    };
    MailListItem.prototype.renderPreviewDisplay = function (previewDisplay) {
        var tableProps = this.props.mailListTableProps;
        return (React.createElement("div", { className: styles.previewDisplayContainer },
            React.createElement("span", { className: styles.previewDisplayText, ref: this.highLightTerms }, previewDisplay),
            tableProps.showFolderTag && !tableProps.isSingleLine && this.renderFolderTag()));
    };
    MailListItem.prototype.renderRichPreviewsWell = function () {
        var itemProps = this.props.mailListItemDataProps;
        var tableProps = this.props.mailListTableProps;
        var tableView = listViewStore.tableViews.get(tableProps.tableViewId);
        var instrumentationContexts = getInstrumentationContextsFromTableView([itemProps.rowKey], tableView);
        return (React.createElement(MailListItemRichPreviewWell, { isWideView: tableProps.isSingleLine, rowId: itemProps.rowId, instrumentationContext: instrumentationContexts[0], onPreviewClick: this.onAttachmentClick }));
    };
    MailListItem.prototype.renderCouponPreviews = function () {
        if (!isControlFeatureEnabled('tri-coupon-peek')) {
            return null;
        }
        var couponPeekPreviews = listViewStore.couponPeekPreviews.get(this.props.mailListItemDataProps.rowId);
        // validCouponIndexes can be undefined when item is not loaded via FindItem
        var hasValidCoupon = this.props.mailListItemDataProps.validCouponIndexes &&
            this.props.mailListItemDataProps.validCouponIndexes.length > 0;
        return hasValidCoupon ? (React.createElement(CouponPreviewWell, { couponContainerClass: this.props.mailListTableProps.isSingleLine
                ? styles.couponPreviewsSingleLine
                : styles.couponPreviewsThreeColumn, couponPreviews: couponPeekPreviews, validCouponIndexes: this.props.mailListItemDataProps.validCouponIndexes })) : null;
    };
    MailListItem.prototype.renderTwistyOrSpinner = function (isExpanded, itemCount, isCondensedView) {
        var isSingleLine = this.props.mailListTableProps.isSingleLine;
        return this.isLoadingExpansion && isMailFeatureEnabled('tri-superConversationExpansion')
            ? this.renderExpansionSpinner(isSingleLine)
            : this.renderTwisty(isExpanded, itemCount, isCondensedView);
    };
    MailListItem.prototype.renderExpansionSpinner = function (isSingleLine) {
        return (React.createElement(Spinner
        // need to stop the event from bubbling up and causing the popout view
        , { 
            // need to stop the event from bubbling up and causing the popout view
            onDoubleClick: this.stopPropagation, className: isSingleLine
                ? styles.loadingItemPartsSpinnerSingleLine
                : styles.loadingItemPartsSpinnerThreeColumn, size: SpinnerSize.xSmall }));
    };
    MailListItem.prototype.renderTwisty = function (isExpanded, itemCount, isCondensedView) {
        var _this = this;
        var hideTwisty = itemCount === 1;
        var isSingleLine = this.props.mailListTableProps.isSingleLine;
        var twistyClasses = classNames(isSingleLine ? styles.twistySingleLine : styles.twistyThreeColumn, hideTwisty && isSingleLine && 'visibilityHidden', hideTwisty && !isSingleLine && 'displayNone');
        return (React.createElement(MailListItemTwistyButton, { className: twistyClasses, isExpanded: isExpanded, onClick: function (evt) {
                onMailListItemClickHandler(evt, MailListItemSelectionSource.MailListItemTwisty, _this.props.mailListItemDataProps.rowKey, _this.props.mailListTableProps.tableViewId);
                if (isCondensedView) {
                    logUsage(datapoints.MailListCondensedRowExpanded.datapoint.name);
                }
            } }));
    };
    MailListItem.prototype.renderIconBar = function () {
        var _a = this.props, mailListTableProps = _a.mailListTableProps, mailListItemDataProps = _a.mailListItemDataProps;
        return (React.createElement(MailListItemIconBar, { mailListItemDataProps: mailListItemDataProps, mailListTableProps: mailListTableProps, supportsHoverIcons: mailListTableProps.supportsHoverIcons, tableViewId: mailListTableProps.tableViewId, rowKey: mailListItemDataProps.rowKey, lastDeliveryTimestamp: mailListItemDataProps.lastDeliveryTimestamp }));
    };
    MailListItem.prototype.renderScheduleTime = function () {
        if (!this.props.mailListItemDataProps.returnTime) {
            return null;
        }
        var formattedDate = getFormattedDate(this.props.mailListItemDataProps.returnTime);
        return (React.createElement("span", { className: styles.scheduleTime, title: formattedDate }, formattedDate));
    };
    // Single line view mail list item structure. Everything is done via flexbox.
    //  Outer Container
    // ---------------------------------------------------------------------------------------------------
    // |  Single Line View Container                                                                     |
    // |  ---------------------------------------------------------------------------------------------  |
    // |  | First Row                                                                                 |  |
    // |  | ------------------------------------------   -------------------------------------------  |  |
    // |  | | First Column                           |   | Second Column                           |  |  |
    // |  | |                                        |   |                                         |  |  |
    // |  | |                                        |   |                                         |  |  |
    // |  | |                                        |   |                                         |  |  |
    // |  | ------------------------------------------   -------------------------------------------  |  |
    // |  ---------------------------------------------------------------------------------------------  |
    // |                                                 ----------------------------------------------  |
    // |                                                 | Attachment Previews Row                    |  |
    // |                                                 |                                            |  |
    // |                                                 ----------------------------------------------  |
    // |                                                 ----------------------------------------------  |
    // |                                                 | Coupon Previews Row                        |  |
    // |                                                 |                                            |  |
    // |                                                 ----------------------------------------------  |
    // ---------------------------------------------------------------------------------------------------
    MailListItem.prototype.renderSingleLineViewMailListItem = function () {
        var itemProps = this.props.mailListItemDataProps;
        var isUnread = itemProps.unreadCount > 0;
        var shouldShowCategories = !!itemProps.categories;
        var subjectClasses = classNames(isUnread ? styles.subjectUnread : styles.subject, shouldShowCategories && styles.paddingLeftForSubjectInSingleLine);
        var isCondensedView = this.props.mailListItemDataProps.showCondensedView;
        var showAttachmentPreviews = !isCondensedView && itemProps.showAttachmentPreview;
        var thirdColumnStyles = this.props.mailListTableProps.showFolderTag
            ? styles.thirdColumnWithFolderTag
            : styles.thirdColumn;
        return (React.createElement("div", { className: styles.singleLineViewContainer },
            React.createElement("div", { className: styles.firstRow },
                React.createElement("div", { className: styles.firstColumn },
                    this.renderTwistyOrSpinner(itemProps.isExpanded, itemProps.itemCount, isCondensedView),
                    React.createElement(PersonaCheckbox, { tableViewId: this.props.mailListTableProps.tableViewId, isSelected: itemProps.isSelected, lastSender: itemProps.lastSender, rowKey: itemProps.rowKey, lastDeliveryTimestamp: itemProps.lastDeliveryTimestamp, isUnauthenticatedSender: itemProps.isUnauthenticatedSender }),
                    this.renderFirstLineText(itemProps.firstLineText, itemProps.firstLineTooltipText, itemProps.showDraftsIndicator, isUnread, itemProps.showBrandDecoration),
                    this.renderIconBar()),
                React.createElement("div", { className: styles.secondColumn },
                    React.createElement("div", { className: styles.content },
                        shouldShowCategories &&
                            this.renderCategories(itemProps.categories, styles.categoryWellSingleLine),
                        React.createElement("div", { className: subjectClasses },
                            this.renderSecondLineText(itemProps.secondLineText, itemProps.secondLineTooltipText),
                            this.renderUnreadCount(itemProps.unreadCount)),
                        this.props.mailListTableProps.showPreviewText && (React.createElement("div", { className: styles.previewDisplaySingleLine }, this.renderPreviewDisplay(itemProps.thirdLineText))))),
                React.createElement("div", { className: thirdColumnStyles },
                    this.renderFolderTag(),
                    this.props.mailListItemDataProps.returnTime
                        ? this.renderScheduleTime()
                        : this.renderTimestamp(isUnread))),
            showAttachmentPreviews && this.renderRichPreviewsWell(),
            this.renderCouponPreviews()));
    };
    MailListItem.prototype.renderThreeColumnViewMailListItem = function () {
        return this.props.mailListItemDataProps.showCondensedView
            ? this.renderCondensedThreeColumnViewMailListItem()
            : this.renderFullThreeColumnViewMailListItem();
    };
    //  Outer Container
    // -------------------------------------------------------------------------
    // |  Three Column FULL View Container                                     |
    // |  ----------------  -------------------------------------------------  |
    // |  | First Column |  |  Second Column                                |  |
    // |  |              |  |  -------------------------------------------  |  |
    // |  |              |  |  | First Row                               |  |  |
    // |  |              |  |  |                                         |  |  |
    // |  |              |  |  -------------------------------------------  |  |
    // |  |              |  |                                               |  |
    // |  |              |  |  -------------------------------------------  |  |
    // |  |              |  |  | Second Row                              |  |  |
    // |  |              |  |  |                                         |  |  |
    // |  |              |  |  -------------------------------------------  |  |
    // |  |              |  |                                               |  |
    // |  |              |  |  -------------------------------------------  |  |
    // |  |              |  |  | Third Row (if not disabled)             |  |  |
    // |  |              |  |  |                                         |  |  |
    // |  |              |  |  -------------------------------------------  |  |
    // |  |              |  |                                               |  |
    // |  |              |  |  -------------------------------------------  |  |
    // |  |              |  |  | Inline Previews                         |  |  |
    // |  |              |  |  |                                         |  |  |
    // |  |              |  |  -------------------------------------------  |  |
    // |  |              |  |                                               |  |
    // |  |              |  |  -------------------------------------------  |  |
    // |  |              |  |  | Coupon Previews                         |  |  |
    // |  |              |  |  |                                         |  |  |
    // |  |              |  |  -------------------------------------------  |  |
    // |  ----------------  -------------------------------------------------  |
    // -------------------------------------------------------------------------
    MailListItem.prototype.renderFullThreeColumnViewMailListItem = function () {
        var itemProps = this.props.mailListItemDataProps;
        var tableProps = this.props.mailListTableProps;
        var isUnread = itemProps.unreadCount > 0;
        var showCategories = !!itemProps.categories;
        var showLabelsContainer = (tableProps.showFolderTag && !tableProps.showPreviewText) || showCategories;
        return (React.createElement("div", { className: styles.threeColumnViewContainer },
            React.createElement("div", { className: styles.firstColumnThreeColumn },
                React.createElement(PersonaCheckbox, { tableViewId: this.props.mailListTableProps.tableViewId, isSelected: itemProps.isSelected, lastSender: itemProps.lastSender, rowKey: itemProps.rowKey, lastDeliveryTimestamp: itemProps.lastDeliveryTimestamp, isUnauthenticatedSender: itemProps.isUnauthenticatedSender })),
            React.createElement("div", { className: styles.column },
                React.createElement("div", { className: isUnread ? styles.firstRowThreeColumnUnread : styles.firstRowThreeColumn },
                    this.renderFirstLineText(itemProps.firstLineText, itemProps.firstLineTooltipText, itemProps.showDraftsIndicator, isUnread, itemProps.showBrandDecoration),
                    this.renderIconBar()),
                React.createElement("div", { className: isUnread
                        ? styles.secondRowThreeColumnUnread
                        : styles.secondRowThreeColumn },
                    this.renderTwistyOrSpinner(itemProps.isExpanded, itemProps.itemCount, false /* isCondensedView */),
                    React.createElement("div", { className: styles.secondLineTextThreeColumn }, this.renderSecondLineText(itemProps.secondLineText, itemProps.secondLineTooltipText)),
                    this.renderUnreadCount(itemProps.unreadCount),
                    this.props.mailListItemDataProps.returnTime
                        ? this.renderScheduleTime()
                        : this.renderTimestamp(isUnread)),
                tableProps.showPreviewText && (React.createElement("div", { className: styles.previewDisplayThreeColumn }, this.renderPreviewDisplay(itemProps.thirdLineText))),
                showLabelsContainer && (React.createElement("div", { className: styles.labelsContainer },
                    !tableProps.showPreviewText && this.renderFolderTag(),
                    showCategories &&
                        this.renderCategories(itemProps.categories, styles.categoryWellThreeColumn))),
                itemProps.showAttachmentPreview && this.renderRichPreviewsWell(),
                this.renderCouponPreviews())));
    };
    //  Outer Container
    // -------------------------------------------------------------------------
    // |  Three Column Condensed View Container                                |
    // |  ----------------  -------------------------------------------------  |
    // |  | First Column |  |  Second Column                                |  |
    // |  |              |  |  -------------------------------------------  |  |
    // |  |              |  |  | Subject                                 |  |  |
    // |  |              |  |  |                                         |  |  |
    // |  |              |  |  -------------------------------------------  |  |
    // |  ----------------  -------------------------------------------------  |
    // -------------------------------------------------------------------------
    MailListItem.prototype.renderCondensedThreeColumnViewMailListItem = function () {
        var itemProps = this.props.mailListItemDataProps;
        var tableProps = this.props.mailListTableProps;
        var isUnread = itemProps.unreadCount > 0;
        var showCategories = !!itemProps.categories;
        var showLabelsContainer = tableProps.showFolderTag || showCategories;
        var containerStyles = classNames(styles.threeColumnViewContainer, styles.isCondensedPinnedRow);
        return (React.createElement("div", { className: containerStyles },
            React.createElement("div", { className: styles.firstColumnThreeColumn },
                React.createElement(PersonaCheckbox, { tableViewId: this.props.mailListTableProps.tableViewId, isSelected: itemProps.isSelected, lastSender: itemProps.lastSender, rowKey: itemProps.rowKey, lastDeliveryTimestamp: itemProps.lastDeliveryTimestamp, isUnauthenticatedSender: itemProps.isUnauthenticatedSender })),
            React.createElement("div", { className: styles.column },
                React.createElement("div", { className: isUnread
                        ? styles.condensedItemFirstRowThreeColumnUnread
                        : styles.condensedItemFirstRowThreeColumn },
                    this.renderTwistyOrSpinner(itemProps.isExpanded, itemProps.itemCount, true /* isCondensedView */),
                    React.createElement("div", { className: styles.condensedItemFirstRowTextThreeColumn }, this.renderCondensedRowText(itemProps.firstLineText, itemProps.firstLineTooltipText, itemProps.showDraftsIndicator)),
                    this.renderUnreadCount(itemProps.unreadCount),
                    this.renderIconBar()),
                showLabelsContainer && (React.createElement("div", { className: styles.labelsContainer },
                    this.renderFolderTag(),
                    showCategories &&
                        this.renderCategories(itemProps.categories, styles.categoryWellThreeColumn))))));
    };
    MailListItem.prototype.render = function () {
        var mailListTableProps = this.props.mailListTableProps;
        return (React.createElement(React.Fragment, null, mailListTableProps.isSingleLine
            ? this.renderSingleLineViewMailListItem()
            : this.renderThreeColumnViewMailListItem()));
    };
    tslib_1.__decorate([
        computed
    ], MailListItem.prototype, "isLoadingExpansion", null);
    MailListItem = tslib_1.__decorate([
        observer
    ], MailListItem);
    return MailListItem;
}(React.Component));
export default MailListItem;
//# sourceMappingURL=MailListItem.js.map